import type { ReactNode } from 'react';
import { useIsProvisioned } from '@/hooks/useIsProvisioned';
import { DynamicFeatureIntro } from '@/components/provisioning';

interface ProvisioningGuardProps {
  children: ReactNode;
}

/**
 * Guard component that checks if user is provisioned.
 * If provisioned, renders children (the actual feature).
 * If not provisioned, renders DynamicFeatureIntro (fetches content from Control Plane).
 */
export function ProvisioningGuard({ children }: ProvisioningGuardProps) {
  const isProvisioned = useIsProvisioned();

  if (!isProvisioned) {
    return <DynamicFeatureIntro />;
  }

  return <>{children}</>;
}
